import { PropsWithChildren } from "react";
import { ModalHeaderProps } from "./types";
import clsx from "clsx";
import { PolymorphicComponent } from "../../../../PolymorphicComponent";

export const modalHeaderStyles = clsx(
  "font-roobert font-bold leading-tight",
  "text-2xl md:text-4xl",
);

export function ModalHeader({
  as = "h1",
  children,
  className,
  dataTestId,
}: PropsWithChildren<ModalHeaderProps>) {
  return (
    <PolymorphicComponent
      as={as}
      className={clsx(modalHeaderStyles, className)}
      data-testid={dataTestId}
    >
      {children}
    </PolymorphicComponent>
  );
}
